module.exports = __webpack_public_path__ + "images/certificate.png?599719fbdb31801231e817981883184c";


//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/views/certificate/components/data/images/certificate.png
// module id = 1bcc6302299232caf319
// module chunks = 9